export const FILE_TYPES = {
  pdf: 'application/pdf'
};

export const UTILITIES = {
  '60d1bc958d706b44be661978': {
    name: 'Cherry Hill',
    values: ['SEWER', 'SERVICE']
  },
  '60d1bc958d706b44be66197a': {
    name: 'Winslow Township',
    values: ['WATER/SEWER', 'SERVICE']
  },
  '60d2154a16e3ee6d16e9ba7a': {
    name: 'Morristown',
    values: ['SEWER', 'WATER']
  }
};

export const DOCUMENT_CATEGORIES = {
  Liens: {
    id: '5e6386ec9f3f361355d6f8b6',
    values: ['Liens', 'Liens']
  },
  Mortgages: {
    id: '5e6386ec9f3f361355d6f8b4',
    values: ['Mortgages', 'Mortgages']
  },
  'Taxes & Assessments': {
    id: '5e6386ec9f3f361355d6f8b5',
    values: ['Taxes & Assessments', 'Taxes, Utilities & Assessments']
  },
  'Chain of Title (Deeds)': {
    id: '5e6386ec9f3f361355d6f8b3',
    values: ['Chain of Title (Deeds)', 'Chain of Title (Deeds)']
  },
  'Tax Maps': {
    id: '5e6386ec9f3f361355d6f8b9',
    values: ['Tax Maps', 'Tax Maps']
  },
  Miscellaneous: {
    id: '5e6386ec9f3f361355d6f8ba',
    values: ['Miscellaneous', 'Miscellaneous']
  },
  Judgments: {
    id: '5e6386ec9f3f361355d6f8b8',
    values: ['Judgments', 'Judgments']
  },
  'Easements & Encumbrances': {
    id: '5e6386ec9f3f361355d6f8b7',
    values: ['Easements & Encumbrances', 'Easements & Encumbrances']
  },
  Summary: {
    id: '5fed919e500d377823d38cec',
    values: ['Summary', 'Summary']
  }
};

export const DATE_FORMAT = 'MM/DD/YYYY';

export const DATE_TIME_FORMAT = 'MM/DD/YYYY HH:mm:ss';

export const JUDGEMENTS_SELECT_DATA = [
  { label: '20 Yrs', value: '20 Yrs' },
  { label: 'ST 5 Yrs 2 Mon', value: 'ST 5 Yrs 2 Mon' },
  { label: 'Fed Liens 10 Yrs', value: 'Fed Liens 10 Yrs' },
  { label: 'Inst Liens 20 Yrs', value: 'Inst Liens 20 Yrs' },
  { label: 'Const Liens 2 Yrs', value: 'Const Liens 2 Yrs' },
  { label: 'Surrogate', value: 'Surrogate' },
  { label: 'Inher.Tax', value: 'Inher.Tax' },
  { label: 'Rec 6 Yrs', value: 'Rec 6 Yrs' },
  { label: 'Dailies to Date', value: 'Dailies to Date' }
];

export const PROPERTY_CLASS_OPTIONS = [
  { label: 'Vacant Land', value: 'Vacant Land' },
  { label: 'Residential', value: 'Residential' },
  { label: 'Farm - Regular', value: 'Farm - Regular' },
  { label: 'Qualified Farm', value: 'Qualified Farm' },
  { label: 'Commercial', value: 'Commercial' },
  { label: 'Industrial', value: 'Industrial' },
  { label: 'Apartment', value: 'Apartment' },
  { label: 'Public School', value: 'Public School' },
  { label: 'Other School', value: 'Other School' },
  { label: 'Public', value: 'Public' },
  { label: 'Church & Charitable', value: 'Church & Charitable' },
  { label: 'Cemetery', value: 'Cemetery' },
  { label: 'Other', value: 'Other' }
];

export const LineBase64 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAV4AAAAPCAYAAACsjqf8AAAAAXNSR0IArs4c6QAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAhGVYSWZNTQAqAAAACAAFARIAAwAAAAEAAQAAARoABQAAAAEAAABKARsABQAAAAEAAABSASgAAwAAAAEAAgAAh2kABAAAAAEAAABaAAAAAAAAAEgAAAABAAAASAAAAAEAA6ABAAMAAAABAAEAAKACAAQAAAABAAABXqADAAQAAAABAAAADwAAAADW7zchAAAACXBIWXMAAAsTAAALEwEAmpwYAAABWWlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS40LjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyI+CiAgICAgICAgIDx0aWZmOk9yaWVudGF0aW9uPjE8L3RpZmY6T3JpZW50YXRpb24+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgpMwidZAAAAyklEQVR4Ae3QWQrCQBAFwKhxuf9tXcd+Mi25gR/WwKMXmwi1LB4BAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEFh2ZXCppO5nrfLts+t994e529b0nePsc79ukn3Puc2c5O5Uya7rec659wgQIPArgUf98bXynLlVTTLnt/T3ymvW7Hqfmn3fZv58Zx1jVO8RIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAwH8LvAFGWhko4Q+oEwAAAABJRU5ErkJggg==';

export const LogoBase64 = 'data:image/png;base64,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';

export const PLAN = {
  '30DAYS': '30-Day Trial',
  MONTHLY: 'Monthly',
  YEARLY: 'Yearly'
};

export const STATUS = [
  {
    key: 'IN_PROGRESS',
    label: 'In Progress',
    color: '#a7a7a7'
  },
  {
    key: 'SUSPICIOUS_ACTIVITY',
    label: 'Suspicious Activity',
    color: 'red'
  },
  {
    key: 'COMPLETE',
    label: 'Complete',
    color: '#3c965a'
  },
  {
    key: 'CLEAR',
    label: 'clear',
    color: '#3c965a'
  }
];

const genericUpload = [
  {
    type: 'autoComplete',
    label: 'Document Type/Title',
    key: 'name'
  },
  {
    type: 'multiple',
    data: [
      {
        type: 'date',
        label: 'Dated',
        key: 'dated'
      },
      {
        type: 'date',
        label: 'Recorded',
        key: 'recorded'
      }
    ]
  },
  {
    type: 'multiple',
    label: 'Instrument/Book/Page',
    data: [
      {
        type: 'text',
        key: 'instrument',
        label: 'Instrument'
      },
      {
        type: 'text',
        key: 'book',
        label: 'Book'
      },
      {
        type: 'text',
        key: 'page',
        label: 'Page'
      }
    ]
  },
  {
    type: 'currency',
    label: 'Amount',
    key: 'amount'
  }
];

export const documentUploadFields = {
  Summary: genericUpload,
  'Chain of Title (Deeds)': [
    {
      type: 'autoComplete',
      label: 'Document Type/Title',
      key: 'name'
    },
    {
      type: 'multiple',
      data: [
        {
          type: 'date',
          label: 'Dated',
          key: 'dated'
        },
        {
          type: 'date',
          label: 'Recorded',
          key: 'recorded'
        }
      ]
    },
    {
      type: 'multiple',
      label: 'Instrument/Book/Page',
      data: [
        {
          type: 'text',
          key: 'instrument',
          label: 'Instrument'
        },
        {
          type: 'text',
          key: 'book',
          label: 'Book'
        },
        {
          type: 'text',
          key: 'page',
          label: 'Page'
        }
      ]
    },
    {
      type: 'text',
      label: 'Grantor',
      key: 'party1'
    },
    {
      type: 'text',
      label: 'Grantee',
      key: 'party2'
    },
    {
      type: 'currency',
      label: 'Consideration Amount',
      key: 'amount'
    }
  ],
  Mortgages: [
    {
      type: 'autoComplete',
      label: 'Mortgage Type/Title',
      key: 'name'
    },
    {
      type: 'currency',
      label: 'Loan Amount',
      key: 'loanAmount'
    },
    {
      type: 'multiple',
      data: [
        {
          type: 'date',
          label: 'Dated',
          key: 'dated'
        },
        {
          type: 'date',
          label: 'Recorded',
          key: 'recorded'
        },
        {
          type: 'date',
          label: 'Satisfied/Discharged/Released/Cancelled',
          key: 'satisfied'
        }
      ]
    },
    {
      type: 'multiple',
      label: 'Instrument/Book/Page',
      data: [
        {
          type: 'text',
          key: 'instrument',
          label: 'Instrument'
        },
        {
          type: 'text',
          key: 'book',
          label: 'Book'
        },
        {
          type: 'text',
          key: 'page',
          label: 'Page'
        }
      ]
    },
    {
      type: 'text',
      label: 'Borrower',
      key: 'party1'
    },
    {
      type: 'text',
      label: 'Lender',
      key: 'party2'
    },
    {
      type: 'text',
      label: 'Trustee',
      key: 'trustee'
    },
    {
      type: 'object',
      label: 'Assignment',
      data: [
        {
          type: 'text',
          label: 'Assignee',
          key: 'assignee.name'
        },
        {
          type: 'date',
          label: 'Recorded',
          key: 'assignee.recorded'
        },
        {
          type: 'multiple',
          label: 'Instrument/Book/Page',
          data: [
            {
              type: 'text',
              key: 'assignee.instrument',
              label: 'Instrument'
            },
            {
              type: 'text',
              key: 'assignee.book',
              label: 'Book'
            },
            {
              type: 'text',
              key: 'assignee.page',
              label: 'Page'
            }
          ]
        }
      ]
    },
    {
      type: 'object',
      label: 'Modification',
      data: [
        {
          type: 'multiple',
          label: 'Instrument/Book/Page',
          data: [
            {
              type: 'text',
              key: 'modification.instrument',
              label: 'Instrument'
            },
            {
              type: 'text',
              key: 'modification.book',
              label: 'Book'
            },
            {
              type: 'text',
              key: 'modification.page',
              label: 'Page'
            }
          ]
        },
        {
          type: 'date',
          label: 'Recorded',
          key: 'modification.recorded'
        },
        {
          type: 'currency',
          label: 'New Loan Amount',
          key: 'modification.loanAmount'
        }
      ]
    }
  ],
  'Taxes & Assessments': [
    {
      type: 'autoComplete',
      label: 'Tax & Utilities Id/Title',
      key: 'name'
    },
    {
      type: 'multiple',
      data: [
        {
          type: 'number',
          label: 'Year',
          key: 'taxYear'
        },
        {
          type: 'date',
          label: 'Last Payment Date',
          key: 'dated'
        },
        {
          type: 'currency',
          label: 'Amount',
          key: 'amount'
        }
      ]
    },
    {
      type: 'multiple',
      data: [
        {
          type: 'date',
          label: 'Due Date',
          key: 'nextDueDate'
        },
        {
          type: 'currency',
          label: 'Amount',
          key: 'dueAmount'
        }
      ]
    },
    {
      type: 'currency',
      label: 'Assessed Value',
      key: 'assessedValue'
    },
    {
      type: 'currency',
      label: 'Exempt Amount',
      key: 'exemptAmount'
    }
  ],
  Liens: [
    {
      type: 'autoComplete',
      label: 'Lien Type/Title',
      key: 'name'
    },
    {
      type: 'multiple',
      data: [
        {
          type: 'date',
          label: 'Dated',
          key: 'dated'
        },
        {
          type: 'date',
          label: 'Recorded',
          key: 'recorded'
        }
      ]
    },
    {
      type: 'multiple',
      label: 'Instrument/Book/Page',
      data: [
        {
          type: 'text',
          key: 'instrument',
          label: 'Instrument'
        },
        {
          type: 'text',
          key: 'book',
          label: 'Book'
        },
        {
          type: 'text',
          key: 'page',
          label: 'Page'
        }
      ]
    },
    {
      type: 'currency',
      label: 'Amount',
      key: 'amount'
    }
  ],
  'Easements & Encumbrances': genericUpload,
  Judgments: [
    {
      type: 'autoComplete',
      label: 'Document Type/Title',
      key: 'name'
    },
    {
      type: 'text',
      label: 'Plaintiff',
      // key: 'plaintiff'
      key: 'plaintiff'
    },
    {
      type: 'text',
      label: 'Defendant',
      key: 'defendant'
    },
    {
      type: 'multiple',
      data: [
        {
          type: 'date',
          label: 'Dated',
          key: 'dated'
        },
        {
          type: 'date',
          label: 'Recorded',
          key: 'recorded'
        }
      ]
    },
    {
      type: 'multiple',
      label: 'Instrument/Book/Page',
      data: [
        {
          type: 'text',
          key: 'instrument',
          label: 'Instrument'
        },
        {
          type: 'text',
          key: 'book',
          label: 'Book'
        },
        {
          type: 'text',
          key: 'page',
          label: 'Page'
        }
      ]
    },
    {
      type: 'currency',
      label: 'Amount',
      key: 'amount'
    }
  ],
  'Tax Maps': genericUpload,
  Miscellaneous: genericUpload
};
